// ==============================|| OVERRIDES - TABLE CELL ||============================== //

export default function TableCell(theme) {
  const isDark = theme.palette.mode === 'dark';

  return {
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderColor: isDark ? (theme.palette?.border?.subtle || 'rgba(255, 255, 255, 0.05)') : '#E2E8F0',
          padding: isDark ? '10px 14px' : '7.2px 12px',
          fontSize: '12.5px',

          '&.MuiTableCell-head': {
            fontSize: '11px',
            fontWeight: 600,
            color: isDark ? (theme.palette?.text?.secondary || '#A4ABB8') : '#475569',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            backgroundColor: isDark ? (theme.palette?.background?.card || '#20242B') : '#F8FAFC',
            borderBottom: isDark ? (theme.palette?.border?.strong ? `1px solid ${theme.palette.border.strong}` : '1px solid rgba(255, 255, 255, 0.13)') : '1px solid #E2E8F0',
            padding: '10px 14px',
            height: '42px',
            boxSizing: 'border-box'
          },

          '&.MuiTableCell-body': {
            color: isDark ? (theme.palette?.text?.primary || '#ECEEF1') : '#0F172A',
            borderBottom: isDark ? (theme.palette?.border?.subtle ? `1px solid ${theme.palette.border.subtle}` : '1px solid rgba(255, 255, 255, 0.05)') : '1px solid #F1F5F9'
          }
        }
      }
    },

    MuiTableRow: {
      styleOverrides: {
        root: {
          height: isDark ? '56px' : '44px',
          boxSizing: 'border-box',
          transition: 'background-color 0.15s ease',
          '&:hover': {
            backgroundColor: isDark ? `${theme.palette?.background?.hover || '#2A2E36'} !important` : '#F8FAFC !important'
          },
          '&:last-child td, &:last-child th': {
            borderBottom: 'none !important'
          }
        }
      }
    },

    MuiTableContainer: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          backgroundColor: isDark ? 'transparent' : '#FFFFFF',
          border: isDark ? 'none' : '1px solid #E2E8F0',
          boxShadow: 'none'
        }
      }
    }
  };
}
